var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"window-container"},[_c(_vm.currentWindow.value,{tag:"component",attrs:{"mode":_vm.currentWindow.mode,"isWindow":true,"closeDialog":_vm.toggleWindow,"fileName":_vm.uploadedFile.fileName}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }